export const config = {
  token_name: 'access_token',
  filters_name: 'settings.filters_001',
  shares_filters_name: 'settings.shares_filters',
  cases_actions: 'settings.cases_actions',
};
